import { Table as MantineTable } from '@mantine/core';
import { useContext } from 'react';

import { TableColumnProps, TableConditionalRowStyles } from '../Table';
import { TableContext } from '../TableContext';
import classes from './TableBody.module.css';

interface TableBodyProps<T> {
  data: T[];
  columns: TableColumnProps<T>[];
  conditionalRowStyles?: TableConditionalRowStyles<T>;
  onRowClick?: (row: T) => void;
}
export const TableBody = <T,>({ data, columns, conditionalRowStyles, onRowClick }: TableBodyProps<T>) => {
  const { stickyClasses } = useContext(TableContext);

  const computeConditionalRowStyle = (row: T) => {
    if (!conditionalRowStyles) {
      return {};
    }

    if (typeof conditionalRowStyles.when === 'function') {
      return conditionalRowStyles.when(row) ? conditionalRowStyles.style : {};
    }
    return conditionalRowStyles.when ? conditionalRowStyles.style : {};
  };

  return (
    <MantineTable.Tbody>
      {(data as unknown as { _id: string }[])?.map((row, rowIdx) => (
        <MantineTable.Tr
          key={row?._id ?? rowIdx}
          style={{
            ...computeConditionalRowStyle(row as T),
            cursor: onRowClick ? 'pointer' : 'default',
          }}
          onClick={() => onRowClick?.(row as T)}
        >
          {columns
            .filter((column) => !column.hide)
            .map((column, index) => {
              return (
                <MantineTable.Td
                  style={{ ...column.style, width: column.width }}
                  key={`${row?._id ?? rowIdx}-${index}`}
                  className={`${column.sticky === 'right' ? stickyClasses.right : ''} ${classes.tdCell}`}
                >
                  {column.cell(row as T, rowIdx) as any}
                </MantineTable.Td>
              );
            })}
        </MantineTable.Tr>
      ))}
    </MantineTable.Tbody>
  );
};
